import Box from '@mui/material/Box';

const smallLogoSrc = '/images/logo-white-text.png';
const wordmarkSrc = '/images/logo.png';
const defaultAlt = 'Social Good Software';

type LogoProps = {
  variant?: 'small' | 'wordmark';
  height?: number;
  alt?: string;
};

export function Logo({ variant = 'small', height = 32, alt = defaultAlt }: LogoProps) {
  if (variant === 'wordmark') {
    return (
      <Box
        component="img"
        src={wordmarkSrc}
        alt={alt}
        sx={{ width: 200, maxWidth: '100%', height: 'auto', display: 'block' }}
      />
    );
  }

  return <Box component="img" src={smallLogoSrc} alt={alt} sx={{ height: height, display: 'block' }} />;
}
